import { WorkflowDetails } from '@/types/workflow-types';
import { apiRequest } from '@/utils/api-request';
import * as Sentry from '@sentry/react';

interface GetWorkflowListResponse {
  data?: {
    success: boolean;
    message: string;
    orgid: string;
    workflows: WorkflowDetails[];
    count: number;
    is_workflow_admin?: boolean;
  };
  detail?: string;
}

/**
 * Fetches the list of workflows for the specified organization from the backend.
 * @param orgId - The organization ID
 * @param signal - Optional AbortSignal to cancel the request
 * @returns Promise containing the workflow list data
 */
export async function getWorkflowList(
  orgId: string,
  signal?: AbortSignal,
): Promise<GetWorkflowListResponse> {
  try {
    const response = await apiRequest<GetWorkflowListResponse>({
      url: `/api/v1/orgs/${orgId}/workflows`,
      target: 'workflow',
      method: 'GET',
      signal,
    });

    return response as GetWorkflowListResponse;
  } catch (error) {
    console.error('Error fetching workflow list:', error);
    Sentry.captureException(error, {
      extra: { context: 'get-workflow-list' },
    });
    throw error;
  }
}
